import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../../../services/api.service';
import { Department } from '../models/department';

/**
 * Base url for api
 */
const BASE_URL = 'departments';

@Injectable({
  providedIn: 'root',
})

/**
 * Department Service
 */
export class DepartmentService {
  /**
   * Is loading
   */
  public loading$: Observable<boolean>;

  /**
   * Constructor
   *
   * @param apiService ApiService
   * @param httpClient HttpClient
   * @param authenticationService AuthenticationService
   */
  constructor(private apiService: ApiService) {
    this.loading$ = this.apiService.loading$;
  }
  /**
   * Create
   *
   * @param department Department instance
   */
  create(department: Department): Observable<any> {
    return this.apiService.post(BASE_URL, department);
  }

  /**
   * Update
   * @param department Department instance
   */
  update(department: Department): Observable<any> {
    const departmentId = department.id;
    delete department.id;
    return this.apiService.patch(`${BASE_URL}/${departmentId}`, department);
  }

  /**
   * Delete
   *
   * @param id Primary key
   */
  delete(id: number): Observable<any> {
    return this.apiService.delete(`${BASE_URL}/${id}`);
  }

  /**
   * List Department
   */
  list(): Observable<Department[]> {
    return this.apiService
      .post(`${BASE_URL}/list`)
      .pipe(map((departments) => departments.map((department) => Department.createFromJson(department))));
  }

  /**
   * Find filtered
   *
   * @param queryOptions Object with query options
   */
  findFiltered(queryOptions): Observable<Department[]> {
    return this.apiService
      .post(`${BASE_URL}/list`, queryOptions)
      .pipe(map((departments) => departments.map((department) => Department.createFromJson(department))));
  }

  /**
   * Get count for filter
   *
   * @param order Order
   * @param sort Sort
   * @param limit Limit
   * @param page Page
   * @param filter Filter object
   */
  // tslint:disable-next-line:max-line-length
  getCount(order: string = 'description', sort: string = 'asc', limit: number = 5, page: number = 0, filter: object = {}): Observable<any> {
    const options = { order, sort, limit, page };

    return this.apiService.post(`${BASE_URL}/count`, { ...options, ...filter });
  }
}
